import { Box, Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { BusyEventContent } from './BusyEventContent';
import { ManualAvailableContent } from './ManualAvailableContent';
import { ManualBookedContent } from './ManualBookedContent';
import { MeetingRoomEventContent } from './MeetingRoomEventContent';
import { SelfFreeSlot } from './SelfFreeSlot';

export const SchEventContentRenderer = ({
  eventInfo,
  registerForUpdates = undefined,
  interviewDataRef,
  updateSharedData,
  removeSlot = undefined,
  onSelect = undefined,
  timezone,
}) => {
  const { event } = eventInfo;

  const type = event.extendedProps.type;

  const { bookedSlot } = interviewDataRef.current;

  const commonProps = {
    eventInfo,
    registerForUpdates,
    interviewDataRef,
    updateSharedData,
    timezone,
  };

  switch (type) {
    case 'manual-available':
      return (
        <ManualAvailableContent
          {...commonProps}
          createNewEvent={(obj) => {
            updateSharedData('bookedSlot', { ...bookedSlot, ...obj });
          }}
        />
      );
    case 'free-slot':
      return <SelfFreeSlot removeSlot={removeSlot} {...commonProps} />;
    case 'busy':
      return (
        <BusyEventContent
          onSelect={onSelect}
          interviewDataRef={interviewDataRef}
          {...commonProps}
        />
      );
    case 'booked':
      return <ManualBookedContent {...commonProps} />;
    case 'meeting_room':
      return <MeetingRoomEventContent {...commonProps} />;
    case 'candidate-availability': {
      const { description, candidateName } = event.extendedProps || {};
      const timeRange = description?.replace(/^Available\s*/i, '') || '';
      return (
        <ManualAvailableContent
          {...commonProps}
          createNewEvent={(obj) => {
            updateSharedData('bookedSlot', { ...bookedSlot, ...obj });
          }}
          slotContent={({ noOfLines, isNarrow }) =>
            isNarrow ? null : (
              <>
                <KText
                  size="xs-semi-bold"
                  color="pastel-2-dark"
                  noOfLines={Math.max(1, noOfLines - 1)}
                >
                  {description}
                </KText>
                {candidateName && (
                  <KText
                    size="xs-semi-bold"
                    color="pastel-2-dark"
                    lineHeight="1.3"
                    noOfLines={1}
                  >
                    {candidateName}
                  </KText>
                )}
              </>
            )
          }
          tooltipLabel={
            <Flex flexDir="column">
              <Box as="p" fontWeight="600">
                Available
              </Box>
              {timeRange && <Box as="p">{timeRange}</Box>}
              {candidateName && <Box as="p">{candidateName}</Box>}
            </Flex>
          }
          contentBoxProps={{ p: '2px 4px' }}
        />
      );
    }
    default:
      return null;
  }
};
